export default __webpack_public_path__ + "static/media/logo-light.964c21b7.svg";